module.exports = __webpack_public_path__ + "img/preview-5.ee02fbd7.png";